import { useMutation } from "@apollo/client";
import { gql } from "generated-graphql";

const OPEN_NEWLY_NOT_REPORTING_REPORTS = gql(`
  mutation OpenNewlyNotReportingReports($facilityIds: [ID!]!, $reportingYear: Int!) {
    openNewlyNotReportingReports(facilityIds: $facilityIds, reportingYear: $reportingYear) {
      createdCount
      skippedCount
    }
  }
`);

export function useOpenNewlyNotReportingReports() {
  return useMutation(OPEN_NEWLY_NOT_REPORTING_REPORTS, {
    refetchQueries: ["ChemicalFacilities"],
  });
}
